// Token persistence for the debug dashboard's login. Unlike the mobile app
// (expo-secure-store) this is a web tool, so tokens live in localStorage. The
// dashboard is internal-only and must not be exposed publicly — localStorage is
// readable by any script on the origin (XSS surface). Access tokens are
// short-lived and refresh tokens rotate, mirroring mobile.
import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'config';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode / quota) — auth simply won't persist */
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getAuthToken(): string | null {
  return safeGet(AUTH_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return safeGet(REFRESH_TOKEN_KEY);
}

export function setTokens(accessToken: string, refreshToken: string): void {
  // Refresh first: a mid-write failure then leaves (old access + new refresh),
  // which is recoverable; the reverse can strand an unusable pair under the
  // backend's single-use refresh rotation.
  safeSet(REFRESH_TOKEN_KEY, refreshToken);
  safeSet(AUTH_TOKEN_KEY, accessToken);
}

export function setAuthToken(accessToken: string): void {
  safeSet(AUTH_TOKEN_KEY, accessToken);
}

export function clearTokens(): void {
  safeRemove(AUTH_TOKEN_KEY);
  safeRemove(REFRESH_TOKEN_KEY);
}
